import { useState } from 'react';

type SiteMode = 'production' | 'construction';

interface UseSiteModeResult {
  mode: SiteMode;
  isLoading: boolean;
}

export const useSiteMode = (): UseSiteModeResult => {
  const [mode, setMode] = useState<SiteMode>('production');
  const [isLoading, setIsLoading] = useState(false);

  return { mode, isLoading };
};
